// Caches how many secondary emails the account has, so the "Email addresses"
// settings card draws the right number of skeleton rows before its request
// resolves. Written after every successful load or change; read synchronously
// when the card sets up. Most accounts have none, hence the default of 0.
//
// Thin, page-specific wrapper around the generic cache. See
// composables/useSkeletonCountCache.js and docs/skeleton_count_caching.md.
import { getCachedSkeletonCount, setCachedSkeletonCount } from './useSkeletonCountCache'

const KEY = 'secondary_emails_count'
const DEFAULT_COUNT = 0

export function getCachedSecondaryEmailsCount() {
  return getCachedSkeletonCount(KEY, DEFAULT_COUNT)
}

export function setCachedSecondaryEmailsCount(count) {
  setCachedSkeletonCount(KEY, count)
}
